import { render, staticRenderFns } from "./answerDatas.vue?vue&type=template&id=17e6a2c3&scoped=true&"
import script from "./answerDatas.vue?vue&type=script&lang=js&"
export * from "./answerDatas.vue?vue&type=script&lang=js&"
import style0 from "./answerDatas.vue?vue&type=style&index=0&id=17e6a2c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e6a2c3",
  null
  
)

export default component.exports